import "./send-proof.scss";
import OrderCollapse from "../../components/order-collapse/order-collapse";
import MyAccountWrapper from "../../layout/my-account-wrapper/my-account-wrapper";
import { FormGroup, Input } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import LogoPix from "../../images/logoPix.png";
import Swal from "sweetalert2";
import iconCopy from "../../images/Icons/iconCopy.svg";
import iconFile from "../../images/Icons/iconFile.svg";
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../../services/api";

const validationSchema = Yup.object().shape({
  proof: Yup.mixed()
    .required("Uma imagem é obrigatória")
    .test(
      "fileType",
      "Somente arquivos de imagem e pdf são permitidos",
      (value) =>
        value &&
        ["image/jpeg", "image/png", "application/pdf"].includes(value.type)
    )
    .test(
      "fileSize",
      "A imagem deve ter no máximo 5MB",
      (value) => value && value.size <= 5 * 1024 * 1024
    ),
});

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

function SendProof() {
  const [fileName, setFileName] = useState("");
  const [fileBinary, setFileBinary] = useState(null);

  const [searchParams] = useSearchParams();
  const order_id = searchParams.get("order_id");

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onBlur",
  });

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("image", fileBinary);
    formData.append("order_id", order_id);
    api
      .post("payment-proof", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Pronto!",
          text: "Comprovante enviado com sucesso.",
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Apenas os formatos jpg, jpeg, png e pdf são aceitos. Por favor, não envie arquivos maiores que 4MB.",
        });
      });
  };

  async function handleCopyToClipboard() {
    await navigator.clipboard.writeText("53.372.842/0001-30");
    Toast.fire({
      icon: "success",
      title: `A chave pix foi copiada para sua área de transferência!`,
    });
  }

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    field.onChange(file);
    const reader = new FileReader();
    reader.onloadend = () => {};
    if (file) {
      reader.readAsDataURL(file);
      setFileBinary(file);
      setFileName(file ? file.name : "");
    }
  };

  return (
    <MyAccountWrapper pageName="Meus Pedidos">
      <div className="send-proof">
        <div className="mb-4 send-proof-description">
          <h2>Pedido #{order_id} reservado com sucesso</h2>
          Agora estamos bem perto de finalizar seu pedido, mas antes é
          necessário enviar o{" "}
          <span className="fw-bold">comprovante de pagamento.</span>
          <br />
        </div>
        <div className="send-step-wrapper">
          <h5 className="fw-bold">
            <span className="step-number">¹</span> Escolha uma das contas abaixo
            para realizar o pagamento
          </h5>
        </div>

        <div className="pix-key-wrapper">
          <div className="name-and-image">
            <img src={LogoPix} className="img-fluid" alt="Brinquedo 1" />
            ALEXSANDRA VIEIRA FRANCA RIBEIRO
          </div>

          <div className="key-and-cnpj">
            <h6>CHAVE PIX CNPJ</h6>
            <h6 className="fw-bold">53.372.842/0001-30</h6>

            <button className="btn copy-btn" onClick={handleCopyToClipboard}>
              <img src={iconCopy} alt="" />
              Copiar chave
            </button>
          </div>
        </div>

        <div className="send-step-wrapper mt-4">
          <h5 className="fw-bold">
            <span className="step-number">²</span> Faça o envio do comprovante
          </h5>
        </div>

        <div className="file-input-wrapper">
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup className="form-group">
              <label htmlFor="proof" className="custom-file-button">
                <img src={iconFile} alt="" />
                Selecionar Comprovante
              </label>
              <Controller
                name="proof"
                control={control}
                render={({ field }) => (
                  <Input
                    type="file"
                    id="proof"
                    style={{ display: "none" }}
                    onChange={(e) => handleFileChange(e, field)}
                  />
                )}
              />
            </FormGroup>
            <div>
              {fileName && (
                <p className="text-muted mt-1">
                  <span className={"fw-bold"}>Arquivo selecionado:</span>{" "}
                  {fileName}
                </p>
              )}
              {errors.file && (
                <span className="text-danger mt-1">{errors.file.message}</span>
              )}
            </div>
            <div className={"submit-btn-wrapper"}>
              <button
                type="submit"
                className={`btn mt-2 ${!fileName ? "btn-disabled" : ""}`}
                disabled={!fileBinary}
              >
                ENVIAR
              </button>
            </div>
          </form>
        </div>
        <div className="mt-4">
          <OrderCollapse orderData={null} />
        </div>
      </div>
    </MyAccountWrapper>
  );
}

export default SendProof;
